import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { BodyTextSmall, HeadingText10, HeadingText30 } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';

import { TopicCard } from './TopicCard';
import { CircleTopicFragment } from '../documents/topic.generated';

const EllipsizedHeader30 = styled(HeadingText30)({
  // -webkit-line-clamp is actually part of the CSS standard
  // See: https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp
  display: '-webkit-box',
  lineClamp: 2,
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const TopicLinkCard: React.FC<{
  topic: CircleTopicFragment;
}> = ({ topic }) => {
  return (
    <Link to={`/circle/${topic.slug}`} css={{ height: '100%' }}>
      <TopicCard
        topic={topic}
        header={EllipsizedHeader30}
        body={BodyTextSmall}
        info={
          topic.sessions.totalCount > 1 ? (
            <span css={{ color: colors.blue55 }}>{` + ${topic.sessions.totalCount - 1} more`}</span>
          ) : undefined
        }
      >
        <HeadingText10 as="p" css={{ whiteSpace: 'nowrap', marginBottom: 8 }} fontColor="blue55">
          <FormattedMessage defaultMessage="See upcoming sessions" />
        </HeadingText10>
      </TopicCard>
    </Link>
  );
};
